import * as core from '../../../../../../../core'

import { query } from './save-subaward-risk-assessment.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.actions.save-subaward-risk-assessment',
    description: 'Save Subaward Risk Assessment',
    name: 'Save Subaward Risk Assessment',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
